<template>
  <div id="mobile-bar" class="mobile-only"></div>
  <div id="main">
    <router-view></router-view>
  </div>
</template>

<style lang="scss">
* {
  box-sizing: border-box;
}

body {
  margin: 0;
  overflow-x: hidden;
  overflow-y: overlay;
}

html {
  font-size: 16px;
}

body,
html {
  height: 100%;
  scroll-behavior: smooth;
}

.container {
  scroll-behavior: smooth;
}

.hide {
  display: none;
}

.no-scroll-body {
  position: fixed;
  width: 100%;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#mobile-bar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 40px;
  background-color: rgb(97, 94, 94);
  z-index: 20;
  box-shadow: 0 0 2px rgb(0 0 0 / 25%);
  pointer-events: none;
}

#project-detail {
  .p-tabview-panels {
    padding: 0;
    margin-top: 0.5rem;
  }
}

.no-scrollbar {
  &::-webkit-scrollbar {
    display: none;
  }
}

.custom-scrollbar::-webkit-scrollbar,
.p-inputtextarea::-webkit-scrollbar {
  width: 4px;
}
.custom-scrollbar::-webkit-scrollbar-track,
.p-inputtextarea::-webkit-scrollbar-track {
  background-color: hsla(200, 100%, 50%, 0.5);
  border-width: 0;
}
.custom-scrollbar::-webkit-scrollbar-thumb,
.p-inputtextarea::-webkit-scrollbar-thumb {
  border-radius: 20px;
  background-color: hsla(250, 100%, 50%, 0.75);
  background-clip: padding-box;
}

.widget {
  position: relative;
  height: 50vh;
  background: #336c99;
  border-radius: 12px;

  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 1rem;
  box-shadow: $standard-shadow;

  &:hover {
    .menu-button {
      opacity: 1;
      pointer-events: initial;
    }
  }

  .title {
    font-size: 1.5rem;
    color: #fff;
    font-weight: 500;
    margin-bottom: 0.5rem;
    text-align: center;
    align-items: center;
  }

  .menu-button {
    cursor: pointer;
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    opacity: 0;
    pointer-events: none;
  }

  .pi {
    color: #fff;
  }
}

.p-checkbox .p-hidden-accessible {
  display: none;
}

.p-progressbar {
  min-height: 20px !important;
  height: 20px !important;
  margin-bottom: 0.5rem;
}

.p-progressbar-determinate .p-progressbar-label {
  display: flex;
  align-items: center;
  justify-content: center;
}

.p-button:focus {
  box-shadow: none !important;
}

.flex-1 {
  flex: 1;
}

.p-dialog .p-dialog-header {
  display: none;
}

.calendar-modal {
  width: 80vw;
  height: 85vh;
  padding: 1rem !important;
  border-radius: 6px;
}

.event-modal {
  width: 20rem;
}

.fc .fc-daygrid-event-harness {
  cursor: pointer;
}

.no-click {
  pointer-events: none;
}

.p-tooltip-text {
  overflow-wrap: break-word;
}

.p-scrollpanel.custombar1 .p-scrollpanel-wrapper {
  border-right: 6px solid var(--surface-b);
}

.p-scrollpanel.custombar1 .p-scrollpanel-bar {
  background-color: var(--primary-color);
}

.p-scrollpanel.custombar1 .p-scrollpanel-bar-y {
  width: 6px;
}

.p-fileupload-row div {
  word-break: break-all !important;
}

.fullscreen-center {
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 9000;
  min-width: 100vw;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mobile-only {
  display: none;
}

.screen-only {
  display: block;
}

.spinner-container {
  position: absolute;
  top: 2rem;
  right: 2rem;
  width: 2.8rem;
  height: 2.8rem;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;

  .p-progress-spinner {
    width: 80%;
    height: auto;
  }
}

ul {
  list-style-type: none;
}

.main-container {
  margin: 0.5rem auto;
  max-width: 70%;
}

.p-accordion-header-link:focus {
  box-shadow: 0 0 0 0.1rem #cecece !important;
}

.p-tabview-nav {
  margin-top: 0.5rem !important;
  padding-right: 35px !important;
  background: #a6d1b5 !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: $standard-shadow;
}

.p-highlight .p-tabview-nav-link {
  color: #6c757d !important;
}

.p-tabview-nav-link {
  background: transparent !important;
  border: none !important;
  color: #fff !important;
}

.p-tabview-nav-link:focus {
  box-shadow: none !important;
}

@media only screen and (max-width: $screen-small) {
  .main-container {
    margin: 2rem;
    max-width: none;
  }
  html {
    font-size: 14px;
  }
  #header {
    display: none;
  }
  #main {
    padding-top: 40px;
  }

  .mobile-only {
    display: block;
  }

  .screen-only {
    display: none;
  }

  #app {
    height: 100%;
  }

  .p-fileupload-row div:first-child {
    padding-left: 0 !important;
    width: calc(25% - 1rem) !important;
  }

  .p-fileupload-row div:nth-child(n + 2):nth-child(-n + 3) {
    width: calc(25% + 1rem) !important;
  }

  .p-fileupload-row div:last-child {
    padding-right: 0 !important;
    width: calc(25% - 1rem) !important;
  }

  .p-galleria-mask .p-galleria-item-nav {
    position: absolute !important;
    top: calc(50% - (#{$mobile-bar} / 2)) !important;
  }

  .spinner-container {
    top: 1rem;
    right: 1rem;
  }

  #project-detail {
    .p-accordion-tab:nth-child(3) {
      .p-accordion-content {
        padding-left: 0.5rem;
        padding-right: 0.5rem;
      }
    }
  }
}
</style>
